var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.permission.data"),
      showSpinner: _vm.isLoading,
      showModal: _vm.showModal,
      showPrimaryFooterButton: false,
      showSecondaryFooterButton: false,
    },
    on: _vm._d({}, [_vm.closeEvent, _vm.onCloseButtonClicked]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _vm.vacation
              ? _c("div", { staticClass: "portal-detail-panel" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "label-description" }, [
                          _vm._v(_vm._s(_vm.$t("pages.permission.status"))),
                        ]),
                        _c(
                          "div",
                          [
                            _vm.vacation.isVacationsConfirmWaiting()
                              ? _c("vacation-confirm-waiting-day-legend")
                              : _vm._e(),
                            _vm.vacation.isVacationsApproved()
                              ? _c("vacations-approved-day-legend")
                              : _vm._e(),
                            _vm.vacation.isVacationsNeedMeeting()
                              ? _c("vacations-need-meeting-day-legend")
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("suc-text-form-show-field", {
                          attrs: {
                            title: _vm.$t(
                              "pages.permission.vacations.start_date"
                            ),
                            value: _vm.vacation.dateStart,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("formatted-date-component", {
                                      attrs: { val: props.value },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            339646096
                          ),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("suc-text-form-show-field", {
                          attrs: {
                            title: _vm.$t(
                              "pages.permission.vacations.end_date"
                            ),
                            value: _vm.vacation.dateEnd,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("formatted-date-component", {
                                      attrs: { val: props.value },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            339646096
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm.vacation.comments
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("suc-text-form-show-field", {
                              attrs: {
                                title: _vm.$t(
                                  "pages.permission.vacations.comments"
                                ),
                                value: _vm.vacation.comments,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.vacation.canRemove()
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 text-right" },
                          [
                            _c("vue-button", {
                              staticClass: "btn-danger button my-1 mx-2",
                              attrs: {
                                title: _vm.$t("components.actions.remove"),
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeVacation.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "body-icon",
                                    fn: function () {
                                      return [
                                        _c("i", {
                                          staticClass: "fas fa-trash-alt",
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2110712871
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }